import React from 'react';

const Hero: React.FC = () => {
  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <h1>클라우드 인프라를 설계하고 자동화하는 엔지니어.</h1>
          <p>안정적이고 확장 가능한 시스템을 구축하여 비즈니스 가치를 더합니다.</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
